import React from "react";
import {Helmet} from "react-helmet";
import Link from "gatsby-link";
import algoliasearch from 'algoliasearch/lite';

/**
 * The 404 error page, inspired from https://codepen.io/srsgores/pen/kgEdA to mimic the BSOD
 */
class PageNotFoundLayout extends React.Component {
    counter;

    constructor(props) {
        super(props);
        this.state = {
            recommendation: [],
            progress: 0,
        };
    }

    componentDidMount() {
        const client = algoliasearch('9DGKY76PYS', 'c5eda5ebf75e6738db41276f6f5b9d18'),
            index = client.initIndex('dev.tonnguyen.com'),
            query = this.props.location.pathname.substring(1).replace(/[-_\/\\^$*+?.()|[\]{}]/g, ' ');
        index.search(query, (err, content) => {
            this.setState({
                recommendation: content.hits
            });
        });
        this.counter = setInterval(() => this.timer(), 20);
    }

    timer() {
        const progress = this.state.progress + 1;
        this.setState({
            progress,
        });
        if (progress >= 100) {
            clearInterval(this.counter);
        }
    }

  render() {
    const recommend = (hits) => (
        <div>
            Here is what we found based on what you are looking for:
            <ul>
                {hits.map(hit => (
                    <li><Link to={'/' + hit.slug} key={hit.slug}>{hit.title}</Link></li>
                ))}
            </ul>
        </div>
    );

    return (
      <div className="tong not-found">
        <Helmet htmlAttributes={{itemtype: 'notfound'}} >
            <meta charSet="utf-8" />
            <meta name="description" content={this.props.data.contentfulSiteSettings.description} />
            <title>{this.props.data.contentfulSiteSettings.title}</title>
            <style>{`
                h1 {
                    font-family: 'Segoe UI Light';
                    font-weight: 300;
                    color: #fff;
                }
                
                html[itemtype='notfound'] body {
                    font-family: 'Segoe UI';
                    color: #fff;
                    background: #008cff;
                    margin: 0;
                }
                
                .not-found main {
                    margin: 4% 10%;
                }
                
                .emotion {
                    font-size: 8em;
                    margin: 0;
                }
                
                .not-found p {
                    font-size: 1.4em;
                }
                
                .not-found a {
                    color: #fff;
                    text-decoration: none;
                }
                
                div[role='recommendation'] {
                    opacity: 1;
                    -webkit-transition: opacity 0.5s linear 2s;
                    -moz-transition: opacity 0.5s linear 2s;
                    -o-transition: opacity 0.5s linear 2s;
                    transition: opacity 0.5s linear 2s;
                }
                
                div[role='recommendation'].hidden {
                    opacity: 0;
                    -webkit-transition: visibility 0s;
                    -moz-transition: visibility 0s;
                    -o-transition: visibility 0s;
                    transition: visibility 0s;
                }
            `}</style>
        </Helmet>
        <main>
            <header>
                <h1 className="emotion">:(</h1>
            </header>
            <p>Your PC ran into a problem and needs to restart. We're just collecting some error info, and then we'll restart for you.</p>
            <p>{ `${this.state.progress}% complete` }</p>
            <div role="recommendation" className={this.state.recommendation.length > 0 ? '' : 'hidden'}>
                {recommend(this.state.recommendation)}
            </div>
        </main>
      </div>
    );
  }
}

export default PageNotFoundLayout;

export const query = graphql`
  query PageQuery {
    contentfulSiteSettings {
      title
      description
    }
}
`;


// WEBPACK FOOTER //
// ./src/layouts/404.index.js